import React from 'react';
import * as R from 'ramda';
import { Skeleton, Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';
import '../../Toolbox.less';
/* import sampleFieldData from '../sampleFieldData.json'; */
import CustomTree from './CustomTree';
import filterFields from './filterFields';
import FieldNodeTitle from './FieldNodeTitle';

const StyledTree = styled(CustomTree)`
  background: none;
  
  .ant-tree-switcher {
    background: rgb(17,44,68) !important;
  }
`;

class Index extends React.Component {
  state = {
    expandedKeys: [],
  };

  computeFilteredFields = R.memoize(filterFields);

  onExpand = (expandedKeys) => {
    this.setState({ expandedKeys });
  };

  // Rendering
  renderFields = (json, filteredFieldKeys, rootKey = '') => {
    const { filterTerm, onInspect } = this.props;

    return (
      Object
        .entries(json)
        .map((pair) => {
          const key = rootKey ? `${rootKey}.${pair[0]}` : pair[0];
          let title = pair[0];

          if (filterTerm && filteredFieldKeys.has(key)) {
            title = (
              pair[0]
                .split(filterTerm)
                .reduce(
                  (acc, substr, i, splitStr) => (
                    splitStr.length - 1 !== i
                      ? [
                        ...acc,
                        substr,
                        <span style={{ color: '#fff' }} key={i}>{filterTerm}</span>,
                      ] : [...acc, substr]
                  ),
                  [],
                )
            );
          } else if (filterTerm) {
            title = <span style={{ opacity: 0.3 }}>{pair[0]}</span>;
          }

          return (
            <Tree.TreeNode
              title={(
                <FieldNodeTitle
                  id={key}
                  onInspect={onInspect}
                >
                  {title}
                </FieldNodeTitle>
              )}
              key={key}
              icon={({ selected }) => (
                <Icon type={selected ? 'frown' : 'frown-o'} />
              )}
            >
              {typeof pair[1] === 'object' && this.renderFields(pair[1], filteredFieldKeys, key)}
            </Tree.TreeNode>
          );
        })
    );
  };

  render() {
    const { expandedKeys } = this.state;
    const { schema, filterTerm, selectedField, onSelect } = this.props;

    const filteredFieldKeys = (
      filterTerm
        ? new Set(this.computeFilteredFields(filterTerm, schema))
        : null
    );

    return (
      <div style={{ background: 'none' }}>
        <StyledTree
          style={{ background: 'none' }}
          showLine={true}
          showIcon={false}
          selectedKeys={selectedField ? [selectedField] : []}
          onSelect={this.handleSelect}
          defaultExpandedKeys={filterTerm ? [...filteredFieldKeys] : []}
          onExpand={this.onExpand}
        >
          {schema && this.renderFields(schema, filteredFieldKeys)}
        </StyledTree>
      </div>
    );
  }
}

export default Index;
